
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_dbt7d_201",
  "refresh": "awsui_refresh_1r9lg_dbt7d_201",
  "animating": "awsui_animating_1r9lg_dbt7d_215",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_dbt7d_238",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_dbt7d_242",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_dbt7d_245",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_dbt7d_248",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_dbt7d_252",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_dbt7d_255",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_dbt7d_258",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_dbt7d_261",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_dbt7d_264",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_dbt7d_268",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_dbt7d_271",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_dbt7d_274",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_dbt7d_277",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_dbt7d_280",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_dbt7d_283",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_dbt7d_287",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_dbt7d_290",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_dbt7d_293",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_dbt7d_296",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_dbt7d_299",
  "root": "awsui_root_1r9lg_dbt7d_303",
  "preferences-button": "awsui_preferences-button_1r9lg_dbt7d_338",
  "close-button": "awsui_close-button_1r9lg_dbt7d_342",
  "drawer-closed": "awsui_drawer-closed_1r9lg_dbt7d_354",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_dbt7d_359",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_dbt7d_375",
  "position-bottom": "awsui_position-bottom_1r9lg_dbt7d_381",
  "position-side": "awsui_position-side_1r9lg_dbt7d_408",
  "slider": "awsui_slider_1r9lg_dbt7d_414",
  "slider-side": "awsui_slider-side_1r9lg_dbt7d_449",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_dbt7d_456",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_dbt7d_467",
  "open-button": "awsui_open-button_1r9lg_dbt7d_478",
  "open-button-side": "awsui_open-button-side_1r9lg_dbt7d_482",
  "slider-icon": "awsui_slider-icon_1r9lg_dbt7d_491",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_dbt7d_497",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_dbt7d_501",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_dbt7d_505",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_dbt7d_516",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_dbt7d_520",
  "content-bottom": "awsui_content-bottom_1r9lg_dbt7d_529",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_dbt7d_545",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_dbt7d_550",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_dbt7d_554",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_dbt7d_558",
  "content-side": "awsui_content-side_1r9lg_dbt7d_563",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_dbt7d_573",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_dbt7d_579",
  "header": "awsui_header_1r9lg_dbt7d_586",
  "header-text": "awsui_header-text_1r9lg_dbt7d_596",
  "header-actions": "awsui_header-actions_1r9lg_dbt7d_609",
  "divider": "awsui_divider_1r9lg_dbt7d_617"
};
  